<template>
  <b-modal
    :id="'EditPhoneNumber-' + whatsapp_resident_people_id"
    @shown="getWhatsappResidentPeopleById"
    hide-footer
    no-close-on-backdrop
    modal-class="modern-modal"
    size="lg"
  >
    <template v-slot:modal-title>
      <div class="modal-title-modern">
        <i class="fas fa-link mr-2"></i>
        Editar Número
      </div>
    </template>

    <div v-if="whatsappResidentPeople" class="modal-content-modern">
      <div class="form-sections">
        <div class="form-section">
          <div class="section-content">
            <div class="form-group">
              <LabelRequiredField label="Nome" />

              <div class="input-wrapper">
                <i class="fas fa-user input-icon"></i>
                <input
                  type="text"
                  v-model="whatsappResidentPeople.name"
                  class="modern-input"
                  placeholder="Digite o nome da pessoa"
                  ref="nameInput"
                />
              </div>
            </div>

            <div class="form-group">
              <LabelRequiredField label="Número de telefone" />

              <div class="input-wrapper">
                <i class="fas fa-phone input-icon"></i>
                <input
                  id="phone_number"
                  v-model="whatsappResidentPeople.phone_number"
                  v-mask="'(##) # ####-####'"
                  type="text"
                  class="modern-input"
                  placeholder="(00) 0 0000-0000"
                  ref="nameInput"
                />
              </div>
            </div>

            <div class="switch-section mr-2">
              <div class="switch-header">
                <i class="fas fa-paper-plane mr-2"></i>
                <span class="switch-title">Envio de mensagem automática</span>
              </div>

              <div class="switch-content">
                <label class="switch-modern">
                  <input
                    type="checkbox"
                    v-model="whatsappResidentPeople.automatic"
                    :disabled="loading"
                    @click="automatic = automatic == false ? true : false"
                  />
                  <span class="slider-modern">
                    <span class="slider-thumb">
                      <i class="fas fa-check thumb-icon"></i>
                    </span>
                  </span>
                </label>
              </div>
            </div>

            <div v-if="whatsappResidentPeople.automatic">
              <div class="form-group">
                <LabelRequiredField label="Dia de envio" />

                <div class="input-wrapper">
                  <i class="fas fa-calendar-day input-icon"></i>
                  <input
                    v-model="whatsappResidentPeople.day"
                    type="number"
                    @input="limitDayLength($event)"
                    class="modern-input"
                    placeholder="Informe o dia para envio da mensagem"
                  />
                </div>
              </div>

              <div class="form-group">
                <LabelRequiredField label="Hora do envio" />

                <div class="input-wrapper">
                  <i class="fas fa-clock input-icon"></i>

                  <select
                    v-model="whatsappResidentPeople.hours"
                    class="modern-input"
                  >
                    <option value="" disabled>Selecione a hora</option>
                    <option value="08:00">08:00</option>
                    <option value="09:00">09:00</option>
                    <option value="10:00">10:00</option>
                    <option value="11:00">11:00</option>
                    <option value="12:00">12:00</option>
                    <option value="13:00">13:00</option>
                    <option value="14:00">14:00</option>
                    <option value="15:00">15:00</option>
                    <option value="16:00">16:00</option>
                    <option value="17:00">17:00</option>
                    <option value="18:00">18:00</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Seção: Mensagens de Erro -->
        <div v-if="errors.length > 0" class="form-section">
          <ErrorsMessages :errors="errors" />
        </div>

        <!-- Seção: Ações -->
        <div class="form-actions">
          <div class="actions-grid">
            <confirmation-dialog
              v-if="permission('remove', 'whatsapp_report_medicine')"
              messageTitle="EXCLUIR"
              openText="EXCLUIR"
              message-body="Deseja realmente excluir esse número?"
              open-class="btn-modern btn-modern-delete"
              open-left-icon="fa-trash"
              @yes="deleteWhatsappResidentPeople(whatsapp_resident_people_id)"
            />

            <v-btn
              :disabled="loading"
              type="submit"
              class="btn-save-modern"
              @click="update"
            >
              <i class="fas fa-save mr-2"></i>
              {{ loading ? "Salvando..." : "Atualizar Número" }}
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages.vue";

import ConfirmationDialog from "../../templates/Components/ConfirmationDialog";

import LabelRequiredField from "../Components/LabelRequiredField";

import toast from "../../lib/ToastNotification";

import api from "../../services/api";

import permission from "../../lib/permission";

export default {
  name: "BindPhoneNumber",

  components: {
    LabelRequiredField,
    ConfirmationDialog,
    ErrorsMessages,
  },

  props: {
    resident_id: Number,
    type: String,
    whatsapp_resident_people_id: Number,
  },

  data() {
    return {
      name: "",

      whatsappResidentPeople: {},

      phone_number: "",

      automatic: false,

      day: 0,

      hours: 0,

      errors: [],

      loading: false,
    };
  },

  mounted() {
    this.getWhatsappResidentPeopleById();
  },

  methods: {
    permission,

    async getWhatsappResidentPeopleById() {
      try {
        this.loading = true;

        let { resident_id, whatsapp_resident_people_id, type } = this;

        let params = { resident_id, whatsapp_resident_people_id, type };

        const response = await api.get("/whatsapp-resident/get", { params });

        const { whatsappResidentPeople } = response.data;

        if (whatsappResidentPeople) {
          whatsappResidentPeople.automatic =
            whatsappResidentPeople.automatic == 1 ? true : false;
        }

        this.whatsappResidentPeople = whatsappResidentPeople;

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.error(error);
      }
    },

    async update() {
      try {
        this.loading = true;

        let { resident_id, whatsapp_resident_people_id, type } = this;

        const name = this.whatsappResidentPeople.name;
        const phone_number = this.whatsappResidentPeople.phone_number;
        const automatic = this.whatsappResidentPeople.automatic;
        const day = this.whatsappResidentPeople.day;
        const hours = this.whatsappResidentPeople.hours;

        let params = {
          resident_id,
          whatsapp_resident_people_id,
          name,
          type,
          phone_number,
          automatic,
          day,
          hours,
        };

        const response = await api.put("/whatsapp-resident", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.errors = [];

          toast(message, "success");

          this.$bvModal.hide(
            "EditPhoneNumber-" + this.whatsapp_resident_people_id
          );

          this.$emit("update");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    async deleteWhatsappResidentPeople() {
      try {
        this.loading = true;

        let whatsapp_resident_people_id = this.whatsapp_resident_people_id;

        let params = { whatsapp_resident_people_id };

        const response = await api.delete("/whatsapp-resident", { params });

        const { error, errors, message } = response.data;

        if (!error) {
          this.errors = [];

          toast(message, "success");

          this.$bvModal.hide(
            "EditPhoneNumber-" + this.whatsapp_resident_people_id
          );

          this.$emit("update");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    limitDayLength(event) {
      let value = event.target.value;

      if (value.toString().length > 2) {
        value = value.toString().slice(0, 2);
      }

      event.target.value = value;

      this.whatsappResidentPeople.day = parseInt(value) || 0;
    },
  },
};
</script>

<style scoped>
.switch-section {
  display: flex;
  align-items: flex-start;
}

.switch-title {
  font-size: 15px;
}

.switch-content {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.switch-modern {
  position: relative;
  display: inline-block;
  width: 54px;
  height: 28px;
  cursor: pointer;
}

.switch-modern input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider-modern {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #cbd5e1;
  transition: 0.4s;
  border-radius: 14px;
  border: 1.5px solid #cbd5e1;
  display: flex;
  align-items: center;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
}

.slider-modern .slider-thumb {
  position: absolute;
  left: 3px;
  top: 4px;
  width: 20px;
  height: 20px;
  background: #e5e7eb;
  border-radius: 50%;
  transition: 0.4s;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transform: translateX(0);
}

.switch-modern input:checked + .slider-modern {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.switch-modern input:checked + .slider-modern .slider-thumb {
  transform: translateX(30px);
}

.switch-modern input:checked + .slider-modern .thumb-icon {
  color: #10b981;
}

.switch-modern input:disabled + .slider-modern {
  opacity: 0.5;
  cursor: not-allowed;
}

.switch-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}

.thumb-icon {
  color: #fff;
  font-size: 14px;
  transition: color 0.3s;
}

.modal-title-modern {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

.modal-title-modern i {
  color: #0f65b0;
}

.modal-content-modern {
  padding: 8px 0;
}

.form-sections {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form-section {
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  transition: all 0.3s ease;
}

.form-section:hover {
  border-color: #cbd5e1;
}

.section-content {
  padding: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 12px;
  color: #6b7280;
  font-size: 14px;
  z-index: 1;
}

.modern-input {
  width: 100%;
  padding: 12px 16px 12px 40px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: white;
  color: #1e293b;
}

.modern-input:focus {
  border-color: #0f65b0;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1);
  outline: none;
}

.modern-input::placeholder {
  color: #9ca3af;
}

.form-actions {
  border-top: 2px solid #e5e7eb;
  padding: 24px 0 8px 0;
  margin-top: 8px;
}

.actions-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.btn-cancel-modern {
  background: transparent !important;
  color: #6b7280 !important;
  border: 2px solid #e5e7eb !important;
  border-radius: 12px !important;
  padding: 14px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
  transition: all 0.3s ease !important;
}

.btn-cancel-modern:hover {
  background: #f8fafc !important;
  border-color: #cbd5e1 !important;
  color: #374151 !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.btn-save-modern {
  background: linear-gradient(135deg, #1e884d 0%, #16a34a 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 14px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(30, 136, 77, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-save-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(30, 136, 77, 0.4) !important;
}

.btn-save-modern:disabled,
.btn-cancel-modern:disabled {
  opacity: 0.7 !important;
  cursor: not-allowed !important;
  transform: none !important;
}
</style>